






























































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import ActivityTab from '@/components/member/memberList/memberEditDrawer/ActivityTab.vue';
import ProfileTab from '@/components/member/memberList/memberEditDrawer/ProfileTab.vue';
import JoinProjectTab from '@/components/member/memberList/memberEditDrawer/JoinProjectTab.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';
import { Account } from '@/@types/Account';
import { ProjectMemberResponse } from '@/@types/ProjectMember';

@Component({
  components: {
    ProfileTab,
    ActivityTab,
    JoinProjectTab,
    AccountIcon
  },
})
export default class MemberDetailDrawerBase extends Vue {
  @Prop({ required: true })
  private isOpenMemberDetailDrawer!: boolean;

  @Prop({ required: true })
  private isMiniMemberDetailDrawer!: boolean;

  @Prop({ required: true })
  private selectedAccount!: Account | null;

  @Prop({ required: true })
  private selectedProjectMember!: ProjectMemberResponse;

  private userIcon: string = require('../../../../assets/test.jpeg');
  private tab = null;
  private scrollY: number = 0;
  private scrollReferencePoint: number = 100;
  private isScrollLower: boolean = false;

  private mounted() {
    const targetElement = document.getElementById('scrollBarTarget');
    if (targetElement) {
      targetElement.addEventListener('scroll', this.handleScroll);
    }
  }

  private handleScroll() {
    const targetElement = document.getElementById('scrollBodyTarget');
    if (targetElement) {
      const clientRect = targetElement.getBoundingClientRect();
      this.scrollY = clientRect.top;
    }
    if (this.scrollY < this.scrollReferencePoint) {
      this.isScrollLower = true;
    } else {
      this.isScrollLower = false;
    }
  }

  /**
   * 指定ページのスクロールをリセットする
   */
  private scrollReset() {
    const target = document.getElementById('scrollBarTarget');
    if (target) {
      target.scrollTo({
        top: 0,
        behavior: 'auto',
      });
    }
  }

  @Emit('mini')
  private mini() {
    this.scrollReset();
  }

  @Emit('open')
  private open() {}

  @Emit('closeMemberDetailDrawer')
  private closeMemberDetailDrawer() {}
}
